<div class="wrapper">
  <div [chart]="chart"></div>
</div>
